// R-167 WU-6a — list hook for /admin/counters.
//
// Thin wrapper around `countersApi.list()` mirroring the conventions of
// `useLookupTables` / `useJobTypes` (load on mount, expose `refetch`).
import { useCallback, useEffect, useState } from "react";
import { countersApi, type CustomCounter } from "../api/client";

export function useCustomCounters() {
  const [counters, setCounters] = useState<CustomCounter[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  const refetch = useCallback(async () => {
    setLoading(true);
    try {
      const result = await countersApi.list();
      setCounters(result.counters);
      setError(null);
    } catch (e) {
      setError(e instanceof Error ? e : new Error(String(e)));
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    void refetch();
  }, [refetch]);

  return { counters, loading, error, refetch };
}
